import {
  Badge,
  Box,
  Center,
  Heading,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/layout";
import { Card, CardBody, type CenterProps } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import type { PermissionList } from "@src/__generated__/graphql";
import { Link } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { observer } from "mobx-react-lite";
import type { LinkProps } from "next/link";
import type { ReactNode } from "react";

export type NavigationCardObject = {
  title: () => string;
  description: () => string;
  bg: CenterProps["bg"];
  href: LinkProps["href"];
  // NOTE: Just until next deploy, then we will remove BETA tag
  isBeta?: boolean;
  permissions?: Array<keyof PermissionList>;
};

export type NavigationCardProps = {
  backgroundColor: CenterProps["backgroundColor"];
  title: ReactNode;
  description: string;
  href: LinkProps["href"];
  linkText: string;
  isBeta?: boolean;
};
export const NavigationCard = observer(function NavigationCard({
  backgroundColor,
  href,
  title,
  description,
  linkText,
  isBeta = false,
}: NavigationCardProps) {
  return (
    <Card>
      <CardBody>
        <HStack spacing="5">
          <Center
            rounded="lg"
            bg={backgroundColor}
            alignSelf="start"
            minH="16"
            minW="16"
            h="16"
            w="16"
          >
            <Icon name="reports" w="6" h="6" />
          </Center>
          <VStack w="full" spacing="5" align="start">
            <HStack spacing="2" align="center">
              <Heading size="sm">
                <Box>{title}</Box>
              </Heading>
              {isBeta && (
                <Badge size="sm">
                  <Box as="span" fontSize="2xs" fontWeight="medium">
                    <Trans>BETA</Trans>
                  </Box>
                </Badge>
              )}
            </HStack>
            <Text>{description}</Text>
            <Link href={href}>
              {linkText}
              <Icon name="chevron-right" color="inherit" />
            </Link>
          </VStack>
        </HStack>
      </CardBody>
    </Card>
  );
});
